module.exports = [
 {
  "start": 125,
  "end": 3291,
  "text": "This apartment called Your room opposite the opera "
 },
 {
  "start": 3333,
  "end": 5291,
  "text": "unites fourteen works created "
 },
 {
  "start": 5375,
  "end": 10125,
  "text": "between 1994-2017 that pose the question "
 },
 {
  "start": 10208,
  "end": 12333,
  "text": "can the electronic light be more "
 },
 {
  "start": 12417,
  "end": 14208,
  "text": "than reproducing the so-called "
 },
 {
  "start": 14250,
  "end": 15834,
  "text": "reality in a lousy way? "
 },
 {
  "start": 16000,
  "end": 18417,
  "text": "Many of these works treat the electronic light "
 },
 {
  "start": 18500,
  "end": 22208,
  "text": "as little ghosts of memory and premonition"
 },
 {
  "start": 22417,
  "end": 23625,
  "text": "i have a big wish "
 },
 {
  "start": 23708,
  "end": 25333,
  "text": "that video can escape "
 },
 {
  "start": 25417,
  "end": 26375,
  "text": "the suspicious box"
 },
 {
  "start": 26500,
  "end": 28208,
  "text": "and that monitors or projectors "
 },
 {
  "start": 28291,
  "end": 29959,
  "text": "are allowed to be more "
 },
 {
  "start": 30083,
  "end": 32959,
  "text": "than exterior story teller."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room8/audio5/08_5MCA The Apartment.js